import React from "react";
import { Input } from "./";
import Autocomplete from "@material-ui/lab/Autocomplete";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import CloseIcon from "@material-ui/icons/Close";
import {
  InputAdornment,
  CircularProgress,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import * as Icons from "@material-ui/icons";

export default function ({
  label,
  className,
  style,
  error,
  helperText,
  name,
  value,
  placeholder,
  loading,
  disabled,
  fullWidth,
  tooltip,
  options,
  type,
  ...props
}) {
  return (
    <FormControl style={style} className={className} fullWidth={fullWidth}>
      {/* {label && <InputLabel error={!!error}>{label}</InputLabel>} */}
      <Autocomplete
        {...props}
        options={Array.isArray(options) ? options : []}
        disabled={loading || disabled}
        disableClearable
        renderInput={({ InputProps, ...params }) => (
          <Input
            {...params}
            required={props.required}
            InputProps={{
              ...InputProps,
              ...(loading && {
                startAdornment: (
                  <InputAdornment position="end">
                    <CircularProgress size={20} color="inherit" thickness={6} />
                  </InputAdornment>
                ),
              }),
              endAdornment: (
                <InputAdornment position="end">
                  <div className="flex-row" style={{ alignItems: "end" }}>
                    {value &&
                      value.length > 0 &&
                      (props.multiple ? props.clearable : true) && (
                        <IconButton
                          onClick={() => {
                            props.onChange(
                              null,
                              type ? (type == "string" ? "" : []) : []
                            );
                          }}
                          size="small"
                        >
                          <CloseIcon style={{ marginRight: "1rem" }} />
                        </IconButton>
                      )}
                    {tooltip ? (
                      <Tooltip title={tooltip} arrow>
                        <Icons.Help
                          style={{
                            verticalAlign: "middle",
                            fontSize: "16px",
                            marginLeft: "5px",
                            marginBottom: "5px",
                          }}
                          color="primary"
                        />
                      </Tooltip>
                    ) : null}
                  </div>
                </InputAdornment>
              ),
            }}
            placeholder={loading ? "Loading Options" : placeholder}
            name={name}
            error={!!error}
            helperText={helperText}
            label={label}
          />
        )}
        value={value === undefined ? null : value} // convert undefined to null
      />
    </FormControl>
  );
}
